import { c as _c } from "react/compiler-runtime";
import type { CollectedDataOption, DataCollectedInfo, DataIdentifier, Actor as TActor } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import FieldList from '@/pages/developers/security-logs/components/timeline/components/event/components/user-data/components/field-list';
import Actor from '../actor';
import getVisibleDis from './utils';
type DataCollectedEventHeaderProps = {
  data: DataCollectedInfo;
};
const DataCollectedEventHeader = t0 => {
  const $ = _c(33);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.dataCollectedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== data.isPrefill || $[2] !== data.isVerifiedPrefill || $[3] !== t) {
    t2 = data.isPrefill || data.isVerifiedPrefill ? t(_temp) : t(_temp2);
    $[1] = data.isPrefill;
    $[2] = data.isVerifiedPrefill;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="text-tertiary">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let title = t3;
  if (data.actor) {
    const t4 = data.actor as TActor;
    let t5;
    if ($[7] !== t4) {
      t5 = <Actor actor={t4} />;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t) {
      t6 = t(_temp3);
      $[9] = t;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t6) {
      t7 = <span className="text-tertiary">{t6}</span>;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t5 || $[14] !== t7) {
      t8 = <>{t5}{t7}</>;
      $[13] = t5;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    title = t8;
  }
  let t4;
  if ($[16] !== data) {
    t4 = getVisibleDis(data);
    $[16] = data;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const {
    visibleDis,
    visibleAttributes
  } = t4;
  let t5;
  if ($[18] !== t) {
    t5 = t(_temp4);
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== title) {
    t6 = <div className="flex items-center gap-1 text-body-2">{title}</div>;
    $[20] = title;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const t7 = visibleDis as DataIdentifier[];
  const t8 = visibleAttributes as CollectedDataOption[];
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <FieldList fields={t7} cdos={t8} numVisibleFields={7} />;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== data.isPrefill || $[26] !== t) {
    t10 = data.isPrefill && <p className="text-body-2 text-tertiary">{t(_temp5)}</p>;
    $[25] = data.isPrefill;
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t5 || $[30] !== t6 || $[31] !== t9) {
    t11 = <div className="flex justify-start items-center gap-1 flex-wrap" aria-label={t5}>{t6}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t5;
    $[30] = t6;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default DataCollectedEventHeader;
function _temp($) {
  return $.titlePrefill;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.titleEdited;
}
function _temp4($_2) {
  return $_2.ariaLabel;
}
function _temp5($_3) {
  return $_3.prefillFromFootprint;
}